import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';

async function getGoogleMapApiKey(){

  const payload={
    apiName: 'LivisiblyGoogleMapApiKeyApi',
    path: 'google_map_api_key'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;
  // console.log("response", response);

  return processResponse(response)
}


export function useGetGoogleMapApiKey(shouldFetch=true){
  // console.log("useGetGoogleMapApiKey", shouldFetch);
  const result = useSWR(
    shouldFetch ? 'GOOGLE_MAP_API_KEY' : null,
    (path) => getGoogleMapApiKey()
  );
  return result;
}
